import API from "../../services/api";

export function previewBulkPayslips(body) {
  return API.post("/bulk-payslips/preview", body).then((r) => r.data);
}

export function createBulkPayslipJob(body) {
  return API.post("/bulk-payslips/jobs", body).then((r) => r.data);
}

export function getBulkPayslipJob(jobId) {
  return API.get(`/bulk-payslips/jobs/${jobId}`).then((r) => r.data);
}

export function listBulkPayslipJobs({ limit = 50, offset = 0 } = {}) {
  return API.get("/bulk-payslips/jobs", { params: { limit, offset } }).then((r) => r.data);
}

export function getBulkPayslipJobItems(jobId, status) {
  return API.get(`/bulk-payslips/jobs/${jobId}/items`, {
    params: status ? { status } : {},
  }).then((r) => r.data);
}

export function cancelBulkPayslipJob(jobId, reason) {
  return API.post(`/bulk-payslips/jobs/${jobId}/cancel`, { reason }).then((r) => r.data);
}

export function retryBulkPayslipJob(jobId) {
  return API.post(`/bulk-payslips/jobs/${jobId}/retry`).then((r) => r.data);
}

export function deleteBulkPayslipJob(jobId) {
  return API.delete(`/bulk-payslips/jobs/${jobId}`).then((r) => r.data);
}

export function downloadBulkPayslipFile(jobId, fileKey) {
  return API.get(`/bulk-payslips/jobs/${jobId}/download/${fileKey}`, {
    responseType: "blob",
  });
}

export function listBulkPayslipAudit(limit = 100) {
  return API.get("/bulk-payslips/audit", { params: { limit } }).then((r) => r.data);
}

export async function saveBulkDownload(blobRes, fallbackName) {
  const cd = blobRes.headers?.["content-disposition"] || "";
  const match = /filename="?([^"]+)"?/.exec(cd);
  const filename = match?.[1] || fallbackName;
  const url = window.URL.createObjectURL(new Blob([blobRes.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
